import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

const Timer = ({seconds, onFinish}) => {
  const [time, setTime] = useState(seconds);
  const timerRef = useRef(null);
  const clearTimer = () => clearInterval(timerRef.current);

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTime(prevTime => prevTime - 1);
    }, 1000);

    return () => clearTimer();
  }, []);

  useEffect(() => {
    if (time === 0) {
      clearTimer();
      onFinish();
    }
  }, [time]);

  const getFormattedTime = secondsValue => {
    const minutes = Math.floor(secondsValue / 60);
    const secondsFotmatted = secondsValue % 60;

    return `${minutes}:${secondsFotmatted < 10 ? `0${secondsFotmatted}` : secondsFotmatted}`;
  };

  return (<>{getFormattedTime(time)}</>);
};

Timer.propTypes = {
  seconds: PropTypes.number.isRequired,
  onFinish: PropTypes.func
};

Timer.defaultProps = {
  onFinish: () => {}
};

export {Timer};
